import React from 'react';

const WaitingStatScreen = ({ currentPlayer }) => {
  return (
    <div className="screen active">
      <div className="card">
        <h2>Waiting...</h2>
        <p>{currentPlayer} is choosing a statistic...</p>
      </div>
    </div>
  );
};

export default WaitingStatScreen;